
define('template!webshopProductsCategoriesView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="header">\n  <div class="clipboard">\n    <div class="libelle">' +
((__t = ( clipboardLabel )) == null ? '' : __t) +
'</div>\n    <div class="clipboard-empty">' +
((__t = ( clipboardEmpty )) == null ? '' : __t) +
'</div>\n    <div class="clipboard-region"></div>\n    <div class="choose-region"></div>\n  </div>\n  <div class="actions">\n    <div class="selection-infos"></div>\n    <div class="paste-region"></div>\n    <div class="remove-region"></div>\n  </div>\n</div>\n<div class="list-region"></div>\n';

}
return __p
};});

